import { useTypedSelector } from "./useTypedSelector";

import { SettingConfigData } from "../../types";

export const useSettingConfig = (): SettingConfigData | null =>
  useTypedSelector(state => state.setting.config);
